export default {
    hrn: '₴',
    hasRemarks: 'Є зауваження!',
    days: ["Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота", "Неділя"],
    validate: {
        Auth: {
            login: {
                required: 'Введіть логін '
            },
            password: {
                required: 'Введіть пароль',
                minLength: 'Мінімальна довжина паролю - 6'
            },
            phone: {
                number: ''
            }
        },
        Resale: {
            compensation: {
                required: 'Введіть компенсацію',
                numeric: 'Компенсація повинна бути цілим числом'
            },
            price: {
                required: 'Введіть ціну',
                numeric: 'Ціна повинна бути цілим числом'
            },
            delay: {
                required: 'Введіть затримку',
                numeric: 'Затримка повинна бути цілим числом'
            },
            compensationInPercent: {
                required: 'Введіть компенсацію у відсотках',
                numeric: 'Компенсація у відсотках повинна бути цілим числом',
                minValue: 'Значення не може бути менше 0',
                maxValue: 'Значення не може бути більше 100'
            },
            priceInPercent: {
                required: 'Введіть ціну у відсотках',
                numeric: 'Ціна у відсотках повинна бути цілим числом',
                minValue: 'Значення не може бути менше 0',
                maxValue: 'Значення не може бути більше 100'
            },
            optionClassId: {
                required: 'Виберіть опцію'
            }
        },
        Brand: {
            code: {
                required: 'Введіть код'
            },
            title: {
                required: 'Введіть назву'
            },
            phoneNumber: {
                required: 'Введіть номер телефону'
            },
            tax: {
                required: 'Введіть збір',
                numeric: 'Збір має бути цілим числом'
            }
        },
        Establishment: {
            name: {
                required: 'Це поле обов`язкове'
            },
            cookTime: {
                required: 'Це поле обов`язкове',
                numeric: 'Значення має бути цілим числом'
            },
            minimalPrice: {
                required: 'Це поле обов`язкове',
                numeric: 'Значення має бути цілим числом'
            },
            place: {
                required: 'Це поле обов`язкове'
            },
            commission: {
                required: 'Це поле обов`язкове',
                decimal: 'Значення має бути числом',
                max: 'Значення має бути не менше 0',
                min: 'Значення має бути не більше 100',
            },
            margin: {
                required: 'Це поле обов`язкове',
                decimal: 'Значення має бути числом',
                max: 'Значення має бути не менше 0',
                min: 'Значення має бути не більше 100',
            },
            type: {
                name: 'Це поле обов`язкове',
            },
            category: {
                required: 'Це поле обов`язкове'
            },
            brand: {
                required: 'Це поле обов`язкове'
            },
            image: {
                required: 'Оберіть зображення'
            }
        },
        Product: {
            name: {
                required: 'Це поле обов`язкове'
            },
            weight: {
                required: 'Це поле обов`язкове',
                numeric: 'Значення має бути числом',
                maxLength: 'Максимальна довжина - 6 символів'
            },
            price: {
                required: 'Це поле обов`язкове',
                numeric: 'Значення має бути числом',
                maxLength: 'Максимальна довжина - 6 символів'
            },
            establishmentAddressId: {
                required: 'Це поле обов`язкове'
            },
            establishment: {
                required: 'Це поле обов`язкове'
            },
            status: {
                required: 'Це поле обов`язкове'
            },
            brand: {
                required: 'Це поле обов`язкове'
            },
            section: {
                required: 'Це поле обов`язкове'
            },
            image: {
                required: 'Оберіть зображення'
            },
            shortDescription: {
                maxLength: 'Максимальна довжина - 255 символів'
            },
            detailedDescription: {
                maxLength: 'Максимальна довжина - 400 символів'
            }
        },
        Notifications: {
            title: {
                required: 'Введіть заголовок'
            },
            body: {
                required: 'Введіть текст',
                maxLength: 'Надто довгий текст'
            }
        },
        Addresses: {
            street: {
                required: 'Введіть назву вулиці'
            },
            name: {
                required: 'Введіть назву місця'
            },
            city: {
                required: 'Введіть місто'
            },
            houseNumber: {
                required: 'Введіть номер будинку'
            },
            latitude: {
                required: 'Введіть широту',
                demical: 'Введіть широту в цифрах'
            },
            longitude: {
                required: 'Введіть довготу',
                demical: 'Введіть довготу в цифрах'
            }
        },
        Bonuses: {
            amount: {
                required: 'Введіть сумму бонусу',
                numeric: 'Введіть сумму в цифрах',
                minValue: 'Сумма повинна бути більша 0.',
            },
            brandId: {
                required: 'Оберіть бренд'
            },
            phones: {
                required: 'Введіть номера телефонів'
            },
            callSigns: {
                required: 'Введіть позивні водіїв'
            },
            bonusUseLimit: {
                title: {
                    required: "Введіть ім'я системи"
                },
                description: {
                    required: "Введіть опис системи"
                },
                bonusFrequency: {
                    required: 'Введіть частоту використання бонусу',
                    numeric: 'Введіть частоту в цифрах',
                    minValue: 'Частота повинна бути більша 0'
                },
                bonusValue: {
                    required: 'Введіть суму бонусу',
                    numeric: 'Введіть суму в цифрах',
                    minValue: 'Сумма повинна бути більша 0'
                },
                bonusValueFromDriver: {
                    required: 'Введіть суму бонуса від водія',
                    maxValue: 'Не повинна бути більша, ніж сума бонусу',
                    numeric: 'Введіть суму в цифрах',
                    minValue: 'Сума повинна бути більша 0'
                },
                startDate: {
                    required: 'Введіть дату початку програми'
                },
                endDate: {
                    required: 'Введіть дату закінчення програми'
                }
            },
            bonusSystem: {
                title: {
                    required: "Введіть ім'я системи"
                },
                description: {
                    required: "Введіть опис системи"
                },
                bonusFrequency: {
                    required: 'Введіть частоту використання бонусу',
                    numeric: 'Введіть частоту в цифрах',
                    minValue: 'Частота повинна бути більша 0'
                },
                bonusValue: {
                    required: 'Введіть суму бонуса',
                    numeric: 'Введіть суму в цифрах',
                    minValue: 'Сумма повинна бути більша 0'
                },
                bonusMaxAmount: {
                    numeric: 'Введіть максимальний розмір бонусу в цифрах'
                },
                skip: {
                    numeric: 'Введіть кількість пропусків в цифрах'
                },
                startDate: {
                    required: 'Введіть дату початку програми'
                },
                endDate: {
                    required: 'Введіть дату закінчення програми'
                }
            }
        },
        Report: {
            name: {
                required: 'Введіть назву звіту',
                minLength: 'Мінімальна кількість символів - 2',
                maxLength: 'Максимальна кількість символів - 255'
            },
            category: {
                maxLength: 'Максимальна кількість символів - 255',
            },
            sqlQuery: {
                required: 'Введіть SQL запит'
            }
        },
        Operators: {
            companyName: {
                required: 'Введіть назву',
                minLength: 'Мінімальна кількість символів - 3',
            }
        },
        User: {
            firstName: {
                required: "Введіть ім'я",
                minLength: 'Мінімальна кількість символів - 2',
                maxLength: 'Максимальна кількість символів - 30'
            },
            lastName: {
                required: 'Введіть прізвище',
                minLength: 'Мінімальна кількість символів - 2',
                maxLength: 'Максимальна кількість символів - 30'
            },
            middleName: {
                required: 'Введіть по-батькові',
                minLength: 'Мінімальна кількість символів - 2',
                maxLength: 'Максимальна кількість символів - 30'
            },
            loginName: {
                required: 'Введіть логін',
                minLength: 'Мінімальна кількість символів - 2',
                maxLength: 'Максимальна кількість символів - 30',
                alphaNum: 'Лише символи латинського алфавіту'
            },
            phoneNumber: {
                required: 'Введіть номер телефону'
            },
            password: {
                required: 'Введіть пароль',
                minLength: 'Мінімальна кількість символів - 6',
                maxLength: 'Максимальна кількість символів - 30'
            },
            email: {
                required: 'Поле обов`язкове для заповнення',
                email: 'Введіть коректну електрону адресу'
            },
            comment: {
                maxLength: 'Довжина примітки перевищує 255 символів'
            },
            brandId: {
                required: 'Оберіть бренд'
            }
        },
        DriverDetails: {
            callSign: {
                required: 'Введіть позивний'
            },
            commissionId: {
                required: 'Оберіть тариф'
            },
            minBalance: {
                required: 'Введіть мінімальний баланс',
                numeric: 'Введені невірні дані',
                maxValue: 'Введений баланс перевищує допустимий',
                minValue: 'Введений баланс нижче допустимого'
            },
            address: {
                required: 'Поле обов`язкове для заповнення'
            },
            passportNumber: {
                required: 'Поле обов`язкове для заповнення'
            },
            passportIssuedBy: {
                required: 'Поле обов`язкове для заповнення'
            },
            passportIssuedWhen: {
                required: 'Поле обов`язкове для заповнення'
            },
            identificationCode: {
                required: 'Поле обов`язкове для заповнення'
            }
        },
        DriverLikes: {
            comment: {
                required: 'Поле обов`язкове для заповнення'
            }
        },
        CommissionTransfer: {
            commissionId: {
                required: 'Оберіть комісію',
                current: 'Ви не можете обрати поточну комісію'
            },
            commissionSystemId: {
                required: 'Оберіть систему комісій'
            }
        },
        Car: {
            year: {
                required: 'Поле обов`язкове для заповнення',
                numeric: 'Введіть рік випуску авто'
            },
            model: {
                required: 'Поле обов`язкове для заповнення'
            },
            color: {
                required: 'Поле обов`язкове для заповнення'
            },
            make: {
                required: 'Поле обов`язкове для заповнення'
            },
            number: {
                required: 'Поле обов`язкове для заповнення'
            }
        },
        DriverPayment: {
            paymentSum: {
                required: 'Введіть суму',
                numeric: 'Дозволено лише цифри'
            },
            paymentComment: {
                maxLength: 'Довжина коментаря перевищує 255 символів',
                required: 'Введіть коментар до платежу'
            },
            penaltyComment: {
                required: 'Введіть коментар до штрафу'
            },
            penaltyId: {
                required: 'Оберіть штраф'
            },
            paymentType: {
                required: 'Оберіть тип платежу'
            },
            orderId: {
                custom: 'Введіть номер замовлення'
            }
        },
        PaymentType: {
            name: {
                required: 'Введіть назву'
            },
            description: {
                required: 'Введіть опис'
            }
        },
        DriverPenalty: {
            title: {
                required: 'Введіть назву штрафа'
            },
            fixedPenalty: {
                required: 'Введіть суму штрафа',
                demical: 'Введіть суму штрафа в цифрах'
            },
            brandId: {
                required: 'Оберіть бренд'
            }
        },
        Options: {
            optionName: {
                required: 'Введіть назву тарифа'
            },
            startPrice: {
                required: 'Введіть стартову плату',
                demical: 'Введіть стартову плату в цифрах'
            },
            priceForKm: {
                required: 'Введіть плату за кілометр',
                demical: 'Введіть плату за кілометр в цифрах'
            },
            priceForWaiting: {
                required: 'Введіть плату за очікування',
                demical: 'Введіть плату за очікування в цифрах'
            },
            minPrice: {
                required: 'Введіть мінімальну плату',
                numeric: 'Введіть мінімальну плату в цифрах'
            },
            multiplier: {
                required: 'Введіть множник тарифа',
                demical: 'Введіть множник тарифа в цифрах'
            },
            multiplierForDriver: {
                required: 'Введіть множник тарифа для водія',
                demical: 'Введіть множник тарифа для водія в цифрах'
            },
            brandId: {
                required: 'Оберіть бренд'
            }
        },
        OptionClasses: {
            className: {
                required: 'Введіть назву'
            }
        },
        DriverCommission: {
            title: {
                required: 'Введіть назву комісії'
            },
            fixedPerOrder: {
                required: 'Введіть плату за замовлення',
                demical: 'Введіть плату за замовлення в цифрах'
            },
            fixedPerDay: {
                required: 'Введіть плату за день роботи',
                demical: 'Введіть плату за день роботи в цифрах'
            },
            fixedPerDeliveryOrder: {
                required: 'Введіть плату за замовлення доставки',
                demical: 'Введіть плату за замовлення доставки в цифрах'
            },
            percentagePerDeliveryOrder: {
                required: 'Введіть відсоток від замовлення доставки',
                demical: 'Введіть відсоток від замовлення доставки в цифрах'
            },
            perDayType: {
                required: 'Введіть тип плати за день'
            },
            fixedPerWeek: {
                required: 'Введіть плату за неділю роботи',
                demical: 'Введіть плату за неділю роботи в цифрах'
            },
            fixedPerMonth: {
                required: 'Введіть плату за місяць роботи',
                demical: 'Введіть плату за місяць роботи в цифрах'
            },
            deliveryDelay: {
                required: 'Введіть затримку',
                demical: 'Введіть затримку в цифрах'
            },
            brandId: {
                required: 'Оберіть бренд'
            }
        },
        DriverCommissionRecalculate: {
            distance: {
                required: 'Введіть відстань',
                minValue: 'Значення має бути більше 0'
            },
            downtime: {
                required: 'Введіть простій',
                minValue: 'Значення має бути більше 0'
            }
        },
        CommissionSystems: {
            name: {
                required: 'Введіть назву'
            },
            brandId: {
                required: 'Оберіть бренд'
            },
            period: {
                required: 'Введіть період',
                numeric: 'Некоректне значення',
                min: 'Менше мінімуму'
            }
        },
        Forms: {
            name: {
                required: 'Введіть назву'
            }
        },
        FormAnswers: {
            phoneNumber: {
                required: 'Введіть номер телефону',
                length: 'Номер телефону некоректний'
            },
            formId: {
                required: 'Оберіть анкету'
            },
            status: {
                required: 'Вкажіть статус'
            }
        },
        PerOrderBorder: {
            leftBorder: {
                required: 'Введіть ліву межу',
                numeric: 'Введіть ліву межу в цифрах'
            },
            rightBorder: {
                required: 'Введіть праву межу',
                numeric: 'Введіть праву межу в цифрах',
                minValue: 'Значення правої межі повинно перевищувати значення лівої межі'
            },
            staticValue: {
                required: 'Введіть статичну комісію',
                demical: 'Введіть статичну комісію в цифрах'
            },
            percentValue: {
                required: 'Введіть відсоткову комісію',
                demical: 'Введіть відсоткову комісію в цифрах'
            }
        },
        TechnicalSupport: {
            type: {
                required: 'Оберіть тип дзвінка'
            },
            phoneNumber: {
                required: 'Введіть номер телефону',
                length: 'Номер телефону некоректний'
            },
            status: {
                required: 'Оберіть статус'
            },
            reason: {
                required: 'Оберіть причину'
            },
            customReason: {
                required: 'Введіть причину'
            },
            comment: {
                maxLength: 'Максимальна довжина - 255 символів'
            }
        },
        PhotoReport: {
            reason: {
                comment: {
                    required: 'Введіть коментарій'
                },
                name: {
                    required: 'Введіть назву причини'
                },
                types: {
                    name: {
                        required: 'Введіть тип фото'
                    }
                }
            },
            photoRequest: {
                name: {
                    required: 'Введіть назву фотозвіту'
                },
                reasonId: {
                    required: 'Введіть причину'
                },
                brandId: {
                    required: 'Виберіть бренд'
                },
                callSigns: {
                    required: 'Введіть позивні'
                },
                checkCallSign: {
                    required: 'Введіть позивний'
                }
            }
        }
    },
    menu: {
        technicalSupport: 'Технічна підтримка',
        deliveryReports: 'Звіти доставки',
        receiveOrders: 'Прийом замовлень',
        formAnswers: 'Опитування',
        driverArticleEditor: 'Редагування водійської новини',
        articleList: 'Список новин',
        importProducts: 'Імпорт товарів',
        dispatcher: {
            title: 'Оператор',
            receiveOrders: 'Прийом замовлень',
            formAnswers: 'Опитування',
            technicalSupport: 'Технічна підтримка'
        },
        // --- Delivery ---
        delivery: {
            title: 'Доставка',
            importProducts: 'Імпорт товарів',
            establishmentsCategories: 'Категорії закладів',
            establishmentsTypes: 'Типи закладів',
            establishments: 'Заклади',
            sections: 'Розділи',
            products: 'Товари',
            deliveryReports: 'Звіти доставки'
        },
        establishmentsCategories: 'Категорії закладів',
        establishmentsTypes: 'Типи закладів',
        establishments: 'Заклади',
        sections: 'Розділи',
        products: 'Товари',
        // --- Delivery end ---
        driverNews: {
            title: 'Новини для водіїв',
            articleList: 'Список новин',
            addDriverArticle: 'Створення новини',
        },
        addDriverArticle: 'Створення водійської новини',
        history: 'Історія',
        map: 'Карта',
        finances: {
            title: 'Фінанси',
            tariffs: 'Тарифи',
            commissions: 'Комісії',
            'commission-systems': 'Системи комісій',
            penalties: 'Штрафи',
            optionClasses: 'Класи опцій',
            paymentTypes: 'Типи платежів'
        },
        users: {
            title: 'Списки',
            operators: 'Користувачі',
            drivers: 'Водії',
            clients: 'Клієнти'
        },
        settings: {
            title: 'Налаштування',
            admin: 'Для адміністратора',
            boss: 'Для директора'
        },
        resales: 'Перепродажа',
        brands: 'Бренди',
        bonuses: {
            title: 'Бонуси',
            driver: 'Для водія',
            client: 'Для клієнта'
        },
        photoReport: {
            title: 'Фотозвіт',
            reasons: 'Список причин',
            review: 'Розгляд фотозвіту',
            reasonCreate: 'Створення причини',
            requestCreate: 'Створення фотозвіту',
            reports: 'Список фотозвітів'
        },
        logging: 'Активність',
        loggingEditor: 'Редагування активності',
        login: 'Вхід',
        reports: 'Звіти',
        addresses: 'Адреси',
        notifications: 'Сповіщення',
        logout: 'Вийти',
        forms: 'Анкети'
    },
    models: {
        Driver: {
            make: 'Марка автомобіля',
            year: 'Рік випуску автомобіля',
            color: 'Колір автомобіля',
            email: 'Почта',
            model: 'Модель автомобіля',
            number: 'Держ. номер автомобіля',
            pledge: 'Застава',
            address: 'Адрес',
            brandId: 'Номер бренда',
            brand: 'Бренд',
            comment: 'Коментар',
            options: 'Опції',
            callSign: 'Позивний',
            lastName: 'Прізвище',
            firstName: 'Ім\'я',
            commission: 'Комісія',
            commissionSystem: 'Система Комісій',
            middleName: 'По-батькові',
            minBalance: 'Мінімальний баланс',
            phoneNumber: 'Телефон',
            commissionId: 'Номер комісії',
            additionalAdresses: 'Додаткові адреси',
            additionalPhoneNumbers: 'Додаткові номери',
            passportNumber: 'Серія и номер',
            passportIssuedBy: 'Виданий (ким)',
            passportIssuedWhen: 'Виданий (коли)',
            identificationCode: 'Ідентифікаційний код',
            comments: 'Коментарі',
            leaderId: 'ID лідера'
        },
        Client: {
            email: 'Електронна пошта',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            birthday: 'Дата народження',
            lastName: 'Прізвище',
            roleName: 'Рівень прав',
            middleName: 'По-батькові',
            firstName: 'Ім\'я',
            phoneNumber: 'Номер телефону',
            comment: 'Коментар'
        },
        Operator: {
            id: 'Id',
            email: 'Електронна пошта',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            comment: 'Коментар',
            lastName: 'Прізвище',
            roleName: 'Рівень прав',
            firstName: 'Ім\'я',
            loginName: 'Логін',
            middleName: 'По-батькові',
            phoneNumber: 'Номер телефону',
            canEditClients: 'Можливість редагування клієнтів',
            canEditDrivers: 'Можливість редагування водіїв',
            canChangeOptionLevel: 'Можливість зміни рівня опцій'
        },
        ClientBonus: {
            title: 'Назва бонусу',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            endDate: 'Кінцева дата',
            isActive: 'статус Активний',
            startDate: 'Початкова дата',
            bonusValue: 'Сума бонусу',
            description: 'Опис',
            bonusFrequency: 'Частота використання бонусу',
            bonusValueFromDriver: 'Сума бонусу від водія'
        },
        Tariff: {
            hidden: 'Прихований',
            brandId: 'Номер бренду',
            districtName: 'Район',
            brand: 'Бренд',
            minPrice: 'Мінімальна плата',
            districtId: 'Район',
            multiplier: 'Множник',
            priceForKm: 'Плата за кілометр',
            startPrice: 'Стартова плата',
            description: 'Опис',
            internal: 'Внутрішнiй',
            priceForWaiting: 'Простій',
            defaultOptions: 'За замовчуванням',
            multiplierForDriver: 'Множник для водіїв',
            optionName: 'Тариф',
            className: 'Тип',
            numberOfSits: 'Кількість місць'
        },
        Resale: {
            delay: 'Затримка',
            price: 'Ціна',
            compensation: 'Компенсація',
            priceInPercent: 'Ціна у відсотках',
            compensationInPercent: 'Компенсація у відсотках'
        },
        Commission: {
            title: 'Назва комісії',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            isDefault: 'За замовчуванням',
            perDayType: 'Тип плати за день',
            fixedPerDay: 'Плата за день роботи',
            fixedPerWeek: 'Плата за тиждень роботи',
            deliveryDelay: 'Затримка',
            fixedPerMonth: 'Плата за місяць роботи',
            fixedPerOrder: 'Плата за замовлення'
        },
        CommissionBorder: {
            leftBorder: 'Ліва межа',
            rightBorder: 'Права межа',
            staticValue: 'Статична комісія',
            percentValue: 'Процентна комісія',
            commissionTitle: 'Назва комісії'
        },
        Penalty: {
            title: 'Назва штрафу',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            fixedPenalty: 'Сума штрафу'
        },
        DriverBonus: {
            title: 'Назва водійського бонусу',
            brandId: 'Номер бренду',
            brand: 'Бренд',
            endDate: 'Кінцева дата',
            isActive: 'статус Активний',
            startDate: 'Початкова дата',
            bonusValue: 'Сума бонусу',
            description: 'Опис',
            bonusFrequency: 'Частота використання бонусу',
            bonusMaxAmount: 'Максимальний розмір бонусу',
            takeOtherBrandOrders: 'Замовлення інших брендів'
        },
        Settings: {
            value: 'Значення',
            comment: 'Коментар',
            forDirector: 'для директора',
            forAdmin: 'для адміністратора'
        },
        Report: {
            name: 'Назва',
            category: 'Категорія',
            sqlQuery: 'Sql запит',
            meta: 'SQL метадані',
            useDates: 'Фільтр по даті',
            useTimes: 'Фільтр по часу',
            useQuery: 'Текстовий запит',
            useBrand: 'Фільтр по брендам',
            useCorp: 'Для корпоративних клієнтів',
            useCompany: 'Фільтр по компаніям'
        },
        Payment: {
            withdrawal: 'Виведення',
            deposit: 'Поповнення',
            penalty: 'Штраф'
        }
    },
    pages: {
        Delivery: {
            addressSchedule: 'Графік роботи адреси',
            Categories: {
                visibility: {
                    shown: 'Відображається',
                    hidden: 'Прихована'
                },
                deleting: 'Видалення категорії',
                areYouSureToDelete: 'Ви дійсно хочете видалити категорію?'
            },
            ImportProducts: {
                chooseAFile: 'Оберіть файл',
                fileToImport: 'Файл для імпорту',
                validationResults: 'Результати перевірки',
                chooseEstablishmentAddress: 'Оберіть адресу закладу',
                productErrors: 'Помилки в товарах',
                newSections: 'Нові розділи',
                products: 'Товари',
                validate: 'Перевірити',
                howToCreateImportFile: 'Як створити файл для імпорту?',
                importFileInstructions: `Це zip архів з csv файлом і картинками
Csv файл має бути з назвою import.csv
Колонки в csv файлі:
Name назва продукту
Count кількість продукту
QuantityType - тип кількості продукту (г, мл, шт, кг)
Price - ціна
Section - назва розділу
ShortDescription - короткий опис
DetailedDescription - опис продукту
Image - назва файлу картинки`,
                productStatuses: {
                    new: 'Нові',
                    updated: 'Оновлені',
                },
                import: 'Імпортувати',
            },
            Products: {
                price: 'Ціна',
                section: 'Розділ',
                amount: 'Кількість',
                picture: 'Картинка',
                shortDescription: 'Короткий опис',
                detailedDescription: 'Детальний опис',
                new: 'Новий'
            },
            photo: 'Фото',
            airAlarm: 'Повітряна тривога'
        },
        History: {
            status: 'Статус',
            deliveryStatus: 'Статус доставки',
            reason: 'Причина відміни',
            brand: 'Бренд',
            all: 'Всі',
            scope: 'Ціль',
            establishment: 'Заклад',
            filterTitle: 'Скинути фільтр',
            table: {
                actions: '',
                id: '#',
                deliveryCancelReason: 'Причина скасування',
                createdAt: 'Час створення',
                gettingOrderTime: 'Час взяття замовлення',
                status: 'Статус',
                statusesHistory: 'Історія статусів',
                client: 'Клієнт',
                cookTime: 'Час приготування',
                address: 'Адреса подання',
                additionAddresses: 'Адреси поїздки',
                options: 'Опції',
                arrivalTime: 'Подання',
                courierStatus: 'Статус кур\'єра',
                problem: 'Зауваження',
                establishment: 'Заклад',
                countOfPersons: 'Прибори',
                products: 'Товари',
                manager: 'Менеджер',
                managerPhoneNumber: 'Телефон менеджера',
                car: 'Машина',
                brandId: 'Бренд',
                operator: 'Диспетчер',
                comments: 'Коментарі',
                price: 'Ціна',
                calculatedPrice: 'Розрахована ціна',
                commentForEstablishment: 'Коментар для закладу',
                tips: 'На чай',
                route: 'Карта',
                routeLength: 'Довжина маршруту',
                stayTime: 'Простій'
            }
        },
        DashboardMap: {
            settings: 'Налаштування карти',
            showDrivers: 'Відображати водіїв',
            showNewOrders: 'Відображати нові замовлення',
            showGroupOrders: 'Відображати групи замовлень',
            orderIdPlaceholder: 'Введіть номер замовлення',
            allBrands: 'Всі бренди',
            errors: {
                accessDenied: 'У Вас немає прав для перегляду цього замовлення.',
                orderNotFound: 'Замовлення із зазначеним Id не існує.',
                noRouteInfo: 'У даному замовленні немає інформації про маршрут.'
            }
        },
        Auth: {
            title: 'Вхід у систему',
            login: 'Логін',
            password: 'Пароль',
            phone: 'SIP'
        },
        Settings: {
            requiredBrand: 'Виберіть бренд, для якого ви хочете відобразити налаштування',
            brand: 'Бренд',
            edit: 'Редагування налаштування',
            default: 'Дефолтні налаштування',
            usedDefault: 'Для цього бренду використовуються основні налаштування',
            action: 'Викл/Вкл',
            table: {
                key: 'Ключ',
                value: 'Значення',
                type: 'Тип значення',
                comment: 'Коментар',
                action: 'Дії'
            },
            types: {
                bots: 'Боти',
                driverUdp: 'Водійський додаток',
                notifications: 'Повідомлення',
                payments: 'Платіжні системи',
                publicApi: 'Публічний сайт',
                karma: 'Карма',
                public: 'Операторський додаток',
                paymentApi: 'Платіжки',
                businessSystem: 'Бізнес система',
                delivery: 'Доставка'
            }
        },
        Brands: {
            brandHasActiveEstablishments: 'Обраний бренд має активні заклади',
            cannotRemoveTitle: 'Неможливо видалити бренд',
            filters: {
                query: 'Запит',
                removed: 'Видалені'
            },
            table: {
                code: 'Код',
                is_vip: 'VIP',
                title: 'Назва',
                phoneNumber: 'Телефон',
                domain: 'Домен',
                defaultOptionId: 'Опція',
                fromCurbOptionId: 'Опція для підсадки',
                tax: 'Збір',
                actions: 'Дії',
                removeTitle: 'Видалення бренду',
                removeQuestion: 'Ви дійсно хочете видалити цей бренд?'
            }
        },
        Forms: {
            table: {
                id: 'Номер анкети',
                name: 'Назва',
                description: 'Опис',
                count: 'Кількість компонентів',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                removeQuestion: 'Ви дійсно хочете видалити анкету?',
                removeDescription: 'Анкету буде повністю видалено з системи'
            },
            editor: {
                create: 'Створення анкети',
                edit: 'Редагування анкети',
                fill: 'Наповнення анкети'
            },
            components: {
                text: 'Текст',
                type: 'Тип',
                order: 'Послідовність',
                options: 'Опції',
                emptyOptions: 'Опції не створені',
                actions: 'Дії'
            },
            types: {
                text: 'Текст',
                'simple-question': 'Просте питання',
                'complex-question': 'Розгорнуте питання',
                'single-choice': 'Один варіант',
                'multiple-choice': 'Кілька варіантів'
            }
        },
        FormAnswers: {
            history: 'Історія опитувань',
            table: {
                id: 'Номер опитування',
                status: 'Статус',
                comment: 'Коментар',
                client: 'Клієнт',
                phoneNumber: 'Номер телефону',
                form: 'Назва',
                operator: 'Оператор',
                createdAt: 'Створено',
                actions: 'Дії'
            },
            statuses: {
                'new': 'Новий',
                'not-interested': 'Не цікавить',
                'cannot-connect': 'Відсутній звязок',
                'call-terminated': 'Обрив дзвінка',
                'to-quality-control': 'На відділ якості',
                'call-back-later': 'Перетелефонувати пізніше',
                'success': 'Успішно',
                'app-success': 'Успішно - додаток',
                'telephony-success': 'Успішно - телефонія',
                'quality-control-success': 'Відділ якості - вирішено',
                'quality-control-failure': 'Відділ якості - не вирішено',
                'returned-promotion-retain': 'Повернувся сам - не видаляти з акції',
                'returned-promotion-remove': 'Повернувся сам - видалити з акції'
            },
            editor: {
                title: 'Анкета',
                phoneNumber: 'Номер телефону',
                formId: 'Анкета',
                status: 'Статус',
                comment: 'Коментар',
                questions: 'Питання'
            }
        },
        ResalesList: {
            brand: 'Бренд',
            switch: 'Продавець/Покупець',
            edit: 'Редагування перепродажі',
            buyer: 'Покупець',
            dealer: 'Продавець',
            compensation: 'Компенсація',
            price: 'Ціна',
            compensationInPercent: 'Компенсація у відсотках',
            priceInPercent: 'Ціна у відсотках',
            delay: 'Затримка',
            percents: 'Обрати у відсотках'
        },
        BrandEditor: {
            create: 'Створення бренду',
            edit: 'Редагування бренду',
            code: 'Код',
            title: 'Назва',
            phoneNumber: 'Телефон',
            domain: 'Домен',
            defaultOptionId: 'Опція',
            fromCurbOptionId: 'Опція для підсадки',
            tax: 'Збір'
        },
        Notifications: {
            success: 'Успішно',
            failure: 'Не успішно',
            count: 'Кількість сповіщень',
            callSigns: 'Позивні',
            brands: 'Бренди',
            driverStatus: 'Статуси водія',
            optionClasses: 'Класи опцій',
            commissions: 'Комісії',
            startDate: 'Початкова дата',
            endDate: 'Кінцева дата',
            sentNotification: 'Відправити сповіщення',
            title: 'Заголовок',
            body: 'Текст',
            imageLink: 'Посилання на зображення',
            description: 'Сповіщення буде відправлено списку обраних водіїв',
            result: 'Результат'
        },
        ReceiveOrders: {
            assign: 'Призначити',
            assignDriver: 'Призначити водія на замовлення',
            assignedSuccessfully: 'Водій {0} успішно призначений на замовлення.',
            assignError: 'Помилка призначення водія на замовлення.',
            title: 'Замовлення',
            ordersSearch: 'Пошук',
            createOrderTitle: 'Замовлення',
            customer: 'Замовник',
            gotAProblem: 'Проблема із замовленням!',
            address: 'Адреса подання',
            house: 'Дім',
            street: 'Вулиця',
            search: 'Почніть вводити для пошуку ...',
            outCity: 'За містом',
            comment: 'Коментар',
            commentLabel: 'Коментар (квартира / під\'їзд / що везти)',
            addAddress: 'Додати адресу',
            arrival: 'Адреса прибуття',
            when: 'Коли',
            changeNumber: 'Змінити номер',
            copyNumber: 'Скопіювати номер',
            now: 'Зараз',
            today: 'Сьогодні',
            tomorrow: 'Завтра',
            brand: 'Бренд',
            autoType: 'Тип авто',
            orderAddress: 'Місцезнаходження замовлення',
            autoRequirements: 'Вимоги до автомобіля',
            tip: 'Додати до суми замовлення:',
            waiting: 'Очікування',
            cancel: 'Скасувати',
            orderHistory: 'Історія замовлень',
            noAddress: 'Адреса не вказана',
            driver: 'Водій',
            preOrder: 'Попереднє замовлення',
            minPreOrderTime: 'Попереднє замовлення. Мінімальний час для попереднього замовлення -',
            forced: 'Примусове призначення',
            nearestCars: 'Найближчі автомобілі',
            appoint: 'Призначити',
            forTea: 'На чай',
            sum: 'В сумі',
            route: 'Маршрут',
            km: 'км',
            min: 'хв',
            callSign: 'Позивний',
            hrn: 'грн',
            recalculate: 'Перерахувати',
            duplicate: 'Дублювати',
            noCars: 'Немає машин',
            noPhone: 'Некоректний номер телефону',
            backToSearch: 'Повернути в пошук',
            calculate: 'Розрахувати',
            save: 'Зберегти',
            edit: 'Редагувати',
            searchAuto: 'Пошук машини',
            searchDriver: 'Введіть позивний водія',
            discount: 'Знижка',
            corporateUser: 'Корпоративний користувач',
            bonusesDiscount: 'Поїздок до знижки',
            increaseTariff: 'Підвищення тарифів',
            goBack: 'Повернутись',
            acceptOrder: 'Прийняти замовлення',
            orderCancellation: 'Скасування замовлення',
            searchCourier: 'Пошук кур\'єра',
            enterCancelReason_textWillBeSentToClient: 'Вкажіть причину відмови. Введений текст буде надісланий клієнту',
            switchStatus: 'Змінити статус',
            prepareTime: 'Час приготування (у хвилинах)',
            delegationOfOrders: 'Передача замовлень іншому оператору',
            chooseOrderReceiver: 'Кому передати Ваші замовлення?',
            transfer: 'Передати',
            operatorName: 'Ім\'я оператора',
            establishment: 'Заклад',
            clientAddress: 'Адреса клієнта',
            establishmentManager: 'Менеджер закладу',
            client: 'Клієнт',
            countOfPersonsDeclinated1: 'на %s персону',
            countOfPersonsDeclinated2: 'на %s персони',
            countOfPersonsDeclinated5: 'на %s персон',
            operator: 'Операторська',
            orderDetails: 'Деталі замовлення',
            commentForEstablishment: 'Коментар до замовлення',
            cancelOrderDetails: {
                details: 'Деталі відміни',
                questionType: 'Тип питання',
                explanation: 'Уточнення',
                resolved: 'Вирішено',
                unresolved: 'Не вирішено',
                questionsList: {
                    'with-driver': 'Питання з водієм',
                    'with-client': 'Питання з клієнтом'
                },
                explanationsList: {
                    'corporation-sum': 'Сума по корпорації',
                    'app-question': 'Питання по додатку',
                    'order': 'Питання по замовленню',
                    'pre-order': 'Питання по попередньому замовленню',
                    'accident-call': 'Помилковий дзвінок',
                    'sos': 'SOS',
                    'no-sms': 'Немає смс',
                    'no-car': 'Немає авто',
                    'tariffs-explanation': 'Уточнення тарифу',
                    'complaint-receive': 'Прийом скарги',
                    'additional-calls': 'Додаткові дзвінки',
                    'admin-transfer': 'Передача адміністратору',
                    'manager-transfer': 'Передача керівництву',
                    'custom': 'Інше'
                }
            },
            previousTariff: 'Тариф попереднього замовлення - <b>"{0}"</b>',
            reducedTariff: 'Знижений тариф',
            settingCurrentOptionLevel: 'Редагування рівня опцій',
            currentOptionLevel: 'Поточний рівень опцій',
            newValue: 'Нове значення'
        },
        Addresses: {
            table: {
                street: 'Вулиця',
                name: 'Місце',
                'street:uk': 'Вулиця (uk)',
                'name:uk': 'Місце (uk)',
                'city:uk': 'Місто (uk)',
                'street:ru': 'Вулиця (ru)',
                'name:ru': 'Місце (ru)',
                'city:ru': 'Місто (ru)',
                'street:en': 'Вулиця (en)',
                'name:en': 'Місце (en)',
                'city:en': 'Місто (en)',
                houseNumber: 'Номер будинку',
                latitude: 'Широта',
                longitude: 'Довгота',
                action: 'Дії'
            },
            latitude: 'Широта*',
            longitude: 'Довгота*',
            edit: 'Редагування адреси',
            create: 'Створення адреси',
            withoutCoordinates: 'Без координат',
            orderId: 'Номер замовлення'
        },
        Bonuses: {
            types: {
                distance: 'За пройденою відстанню',
                count: 'За кількістю замовлень'
            },
            targetTypes: {
                all: 'Всі',
                taxi: 'Таксі',
                delivery: 'Доставка'
            },
            table: {
                type: 'Тип бонусної системи',
                title: 'Назва системи',
                description: 'Опис системи',
                bonusFrequency: 'Частота використання',
                bonusValue: 'Сумма бонусу(грн.)',
                fixedBonusAmount: 'Фіксований бонус',
                bonusMaxAmount: 'Максимальний розмір бонуса',
                bonusMaxOrderAmount: 'Максимальний бонус за замовлення',
                startDate: 'Початок програми',
                endDate: 'Кінець програми',
                isActive: 'статус Активний',
                brandId: 'Бренд',
                driverCount: 'Активних водіїв',
                receivedBonuses: 'Отриманих бонусів',
                actions: 'Дії',
                targetType: 'Ціль',
                bonusValueFromDriver: 'Сума бонусу від водія(грн.)',
                usersCount: 'Активних користувачів',
                refillBalance: 'Нараховано бонусів',
                useBalance: 'Витрачено бонусів',
                leftBalance: 'Залишилось бонусів',
                revertBalance: 'Знято бонусів',
                skip: 'Пропусків'
            },
            editor: {
                addBonuses: 'Нарахувати бонуси',
                addBonusesAgain: 'Нарахувати бонуси ще раз',
                title: 'Нарахування бонусів',
                phoneNumbers: 'Номера телефонів',
                callSigns: 'Позивні водіїв',
                bonusAmount: 'Кількість бонусів (грн.)',
                brand: 'Бренд',
                bonusSystem: 'Система використання бонусів',
                bonusSystemName: ':bonusValue грн. кожну :bonusFrequency поїздку (з :startDate по :endDate)',
                generatedSmsText: 'Вам нараховано :amount грн. бонусу. З :startDate по :endDate знижка :bonusValue грн. на кожну :bonusFrequency поїздку.',
                generatedSmsTextForDriver: 'Вітаємо! Ти став участником акції від :brandName. За кожнe :bonusFrequency замовлення отримай :bonusValue грн бонусу',
                transferBonuses: 'Зберегти попередні бонуси',
                smsSend: 'Відправити смс повідомлення',
                smsTransliteration: 'Транслітерувати',
                smsText: 'Текст смс',
                mainTitle: 'Система використання бонусів',
                mainTitleForDriver: 'Система використання бонусів для водіїв',
                takeOtherBrandOrders: 'Замовлення інших брендів',
                removeQuestion: 'Бажаєте видалити бонусну систему?',
                removeDescription: 'Дана бонусна система буде повністю видалена'
            },
            info: {
                callSign: 'Позивний',
                phone: 'Номер телефона',
                refillBalance: 'Нараховано бонусів',
                useBalance: 'Використано бонусів',
                revertBalance: 'Списані бонуси',
                leftBalance: 'Не використані бонуси',
                orderCount: 'Кількість поїздок',
                bonusOrderCount: 'Кількість бонусних поїздок',
                receivedBonuses: 'Отримано бонусів',
                brandOrderCount: 'Замовлення бренда',
                totalOrderCount: 'Всі замовлення',
                details: 'Детальна інформація',
                noActiveUsers: 'В даній бонусній системі ще немає активних користувачів',
                successAdded: 'Успішно нараховано',
                countOfBonuses: 'Кількість нарахованих бонусів',
                countOfTransferedBonuses: 'Кількість перенесених бонусів з інших систем'
            },
            validate: {
                success: 'Успішно',
                notFound: 'Не знайдено',
                duplicate: 'Дублікати',
                otherBonusSystem: 'Інші бонусні системи',
                validationError: 'Помилка валідації'
            }
        },
        DeliveryReports: {
            table: {
                date: 'Дата',
                orderCnt: 'Замовлень',
                cancelledCnt: 'Скасованих замовлень',
                commissionPercent: 'Відсоток комісії',
                paidCommission: 'Оплачено комісії',
                earned: 'Продано на суму',
                clearProfit: 'Чистий прибуток',
                soldSum: 'Сума проданих товарів',
                brandLoan: 'Борг перед брендом',
                totalCommission: 'Сума комісії',
                bonusOrderCnt: 'Кількість бонусних замовлень',
                productSum: 'Сума проданих товарів',
                deliveryPrice: 'Сума доставки',
                driverBonusAmount: 'Сума доплат водіям за доставку',
                totalRouteLength: 'Сума відстаней',
                totalMargin: 'Сума націнки',
                deliveryOrderId: 'Номер замовлення',
                callSign: 'Позивний',
                driverDistance: 'Відстань до закладу',
                forcedOrdersCount: 'Кількість автозахватів',
                forcedOrdersAcceptedCount: 'Кількість взяття автозахватів',
                forcedOrdersDeclinedCount: 'Кількість відмов від автозахватів',
                orderCreated: 'Дата і час створення замовлення',
                orderOpened: 'Дата і час відкриття замовлення',
                orderID: 'Номер замовлення',
                openDuration: 'Час відкриття замовлення',
                managerFIO: 'ПІБ менеджера',
                finalOrderStatus: 'Фінальний статус замовлення',
                orderAccepted: 'Дата і час прийняття замовлення',
                acceptedDuration: 'Час прийняття замовлення',
                operatorFIO: 'ПІБ оператора',
                avgAcceptedDuration: 'Середній час прийняття замовлення',
                minAcceptedDuration: 'Мінімальний час прийняття замовлення',
                maxAcceptedDuration: 'Максимальний час прийняття замовлення',
                ordersCount: 'Кількість замовлень',
                avgOpenDuration: 'Середній час відкриття замовлення',
                minOpenDuration: 'Мінімальний час відкриття замовлення',
                maxOpenDuration: 'Максимальний час відкриття замовлення',
                successfullyTestOrdersCnt: 'Кількість успішних тестових замовлень',
                canceledTestOrdersCnt: 'Кількість скасованих тестових замовлень',
                canceledTestOrdersSum: 'Сума скасованих тестових замовлень',
                canceledOrdersByClientBeforePaymentCnt: 'Кількість скасованих замовлень клієнтом до оплати',
                canceledOrdersByClientAfterPaymentCnt: 'Кількість скасованих замовлень клієнтом після оплати',
                canceledOrdersByClientAfterPaymentSum: 'Сума скасованих замовлень клієнтом після оплати',
                canceledOrdersByEstBeforePaymentCnt: 'Кількість скасованих замовлень закладом до оплати',
                canceledOrdersByEstAfterPaymentCnt: 'Кількість скасованих замовлень закладом після оплати',
                canceledOrdersByEstAfterPaymentSum: 'Сума скасованих замовлень закладом після оплати',
                taxiOrderId: 'Номер замовлення',
                distanceToClient: 'Відстань до клієнта',
            },
            types: {
                dailyProfit: 'Звіт керівника компанії №1',
                brandFinance: 'Фінансовий по бренду',
                deliveryDriverBonuses: 'Доплата водіям за доставку',
                productAnalytics: 'Звіт керівника компанії №2',
                forcedAnalyticsAccepted: 'Аналітика взяття автозахватів',
                forcedAnalyticsDeclined: 'Аналітика відмови від автозахватів',
                operatorAnalytics: 'Аналітика роботи операторів',
                managerAnalytics: 'Аналітика роботи менеджерів',
                operatorMainAnalytics: 'Аналітика роботи операторів (загальний)',
                managerMainAnalytics: 'Аналітика роботи менеджерів (загальний)',
                canceledAndTestOrders: 'Скасовані та тестові замовлення',
                forcedAnalyticsDeclinedTaxi: 'Аналітика відмови від автозахватів (таксі)',
            },
            categories: {
                financialDeliveryReports: 'Фінансові звіти доставки',
                forcedAnalytics: 'Робота з кур\'єрами',
                orderProcessingAnalytics: 'Аналітика роботи з замовленнями',
                forcedAnalyticsTaxi: 'Робота з таксі',
            },
            all: 'Звіти доставки',
            allEstablishments: 'Усі заклади',
            allBrands: 'Усі бренди',
            establishment: 'Заклад',
            brand: 'Бренд'
        },
        Reports: {
            all: 'Звіти',
            another: 'Інші',
            category: 'Категорія',
            orderId: 'Номер замовлення',
            report: 'Звіт',
            empty: 'У вас немає доступу до звітів.',
            query: 'Запит',
            brand: 'Бренд',
            company: 'Компанія',
            startDate: 'Початкова дата',
            endDate: 'Кінцева дата',
            startTime: 'Час початку',
            endTime: 'Час кінця',
            table: {
                number: '#',
                name: 'Назва',
                category: 'Категорія',
                sqlQuery: 'Sql запит',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                action: 'Дії'
            },
            editor: {
                create: 'Створення звіту',
                edit: 'Редагування звіту',
                meta: 'SQL метадані',
                useDates: 'Фільтр по датам',
                useTimes: 'Фільтр по часу',
                useQuery: 'Текстовий запит',
                useBrand: 'Фільтр по брендам',
                useCorp: 'Для корпоративних клієнтів',
                useCompany: 'Фільтр по компаніям',
                removeQuestion: 'Бажаєте видалити звіт?',
                removeDescription: 'Даний звіт буде повністю видалена'
            }
        },
        Users: {
            query: 'Запит',
            startDate: 'Початкова дата',
            endDate: 'Кінцева дата',
            all: 'Всі',
            table: {
                userId: '#',
                birthday: 'День народження',
                fullName: 'ПІБ',
                firstName: "Ім'я",
                lastName: 'Прізвище',
                middleName: 'По-батькові',
                phoneNumber: 'Телефон',
                email: 'Електронна пошта',
                comment: 'Коментар',
                establishmentAddress: 'Адрес закладу',
                loginName: 'Логін',
                roleName: 'Рівень прав',
                createdAt: 'Прийнято на роботу',
                updatedAt: 'Звільнено',
                lastActiveTime: 'Остання активність',
                brandId: 'Бренд',
                actions: 'Дії',
                callSign: 'Позивний',
                driverStatus: 'Статус',
                shortCarInfo: 'Автомобіль',
                imei: 'IMEI',
                address: 'Адрес',
                establishmentAddressId: 'Адреса закладу',
                commission: 'Комісія',
                karma: 'Карма',
                commissionSystem: 'Система Комісій',
                additionalPhoneNumbers: 'Додаткові номери',
                additionalAdresses: 'Додаткові адреси',
                minBalance: 'Мінімальний баланс',
                pledge: 'Застава',
                password: 'Пароль',
                canEditClients: 'Відображати замовлення інших операторів',
                canChangeOptionLevel: 'Можливість зміни рівня опцій',
                canEditDrivers: 'Можливість редагування водіїв',
                extendedCapabilities: 'Розширені можливості',
                leaderId: 'Лідер',
                establishmentId: 'Заклад',
                categoryId: 'Категорія'
            },
            client: {
                edit: 'Редагування клієнта',
                create: 'Створення клієнта'
            },
            operator: {
                edit: 'Редагування користувача',
                create: 'Створення користувача',
                removeQuestion: 'Бажаєте видалити даного користувача?',
                removeDescription: 'Даному користувачу буде встановлено статус - видалений.',
                company: {
                    edit: 'Редагування компанії',
                    title: 'Назва компанії'
                }
            },
            driver: {
                edit: 'Редагування водія',
                create: 'Створення водія',
                options: 'Опції',
                tariffs: 'Тарифи',
                removeQuestion: 'Бажаєте видалити даного водія?',
                removeDescription: 'Даному водію буде встановлено статус - видалений.',
                payments: 'Історія платежів',
                changePasswordText: 'Встановлений пароль:',
                comments: 'Коментарі',
                newComment: 'Новий коментар',
                reRegistration: 'Остання перевірка',
                additionalDriver: 'Додатковий акаунт',
                withoutAdditionalDriver: 'Не підключений',
                tied: 'Підключений',
                mainDriver: 'Основний акаунт',
                deliveryConfidence: 'Допуск до замовлень доставки',
                confidenceLevels: {
                    under: 'До',
                    all: 'Усі'
                },
                present: 'Присутній',
                disabled: {
                    title: 'Блокування неперевірених водіїв',
                    text: 'Оберіть мінімальну дату останньої перевірки для можливості бути в ефірі. З ефіру будуть зняті всі водії, у яких дата останньої перевірки менше зазначеної (або відсутній взагалі)'
                },
                car: {
                    color: 'Колір',
                    model: 'Модель',
                    make: 'Марка',
                    year: 'Рік випуску',
                    number: 'Держ. номер'
                },
                status: {
                    active: 'В ефірі',
                    offline: 'В ефірі',
                    disabled: 'Знятий з ефіру',
                    online: 'Онлайн',
                    removed: 'Звільнений'
                },
                driverOptions: {
                    disable: 'Зняти з ефiру',
                    enable: 'Повернути в ефiр',
                    edit: 'Редагувати',
                    clearImei: 'Скинути IMEI',
                    clearCode: 'Скинути код додатку',
                    sendPassword: 'Відправити пароль'
                },
                passportData: {
                    title: 'Паспортні дані',
                    number: 'Серія и номер',
                    issuedBy: 'Виданий (ким)',
                    issuedWhen: 'Виданий (коли)',
                    identificationCode: 'Ідентифікаційний код'
                }
            },
            payments: {
                addPenalty: 'Ошрафувати',
                addPayment: 'Провести платіж',
                penalty: 'Штраф',
                penaltyComment: 'Коментар до штрафу',
                payment: 'Платіж',
                commissionText: 'Штраф:',
                balance: 'Баланс',
                paymentTypeByComment: 'Тип платежу (коментар)',
                paymentType: 'Тип платежу',
                noItems: 'Платежі за заданими параметрами не знайдені',
                paymentSum: 'Сума платежу',
                paymentComment: 'Коментар',
                createdAt: 'Дата',
                orderId: 'Замовлення',
                fullNameForPayment: 'Вніс оплату',
                types: {
                    'manual-replenishment': 'Ручне поповнення',
                    'cashless-sprut': 'Безнал Sprut',
                    'cashless-manual': 'Безнал',
                    'cash-out': 'Виведення коштів',
                    'receipt': 'Квитанція',
                    'employee': 'Співробітник',
                    'mistake': 'Помилка',
                    'transfer-plus': 'Перекидка в +',
                    'transfer-minus': 'Перекидка в -',
                    'penalty': 'Штраф',
                    'return': 'Повернення'
                },
                commission: {
                    recalculate: 'Перерахування комісії',
                    distance: 'Відстань (км)',
                    downtime: 'Простій (хв)',
                    warning: 'Комісію буде змінено при збереженні',
                    total: 'Комісія складає'
                }
            }
        },
        Options: {
            optionClass: 'Тип',
            optionName: 'Тариф',
            brand: 'Бренд',
            table: {
                optionName: 'Тариф',
                optionClassId: 'Тип',
                districtId: 'Район',
                description: 'Коментар',
                startPrice: 'Стартова плата(грн.)',
                priceForKm: 'Плата за кілометр(грн.)',
                priceForWaiting: 'Простій(10 хв)',
                minPrice: 'Мінімальна плата(грн.)',
                multiplier: 'Множник(разів)',
                multiplierForDriver: 'Множник для водіїв(разів)',
                defaultOptions: 'За замовчуванням',
                internal: 'Внутрішнiй',
                hidden: 'Прихований',
                brandId: 'Бренд',
                actions: 'Дії',
                duplicate: 'Дублювати тариф',
                numberOfSits: 'Кількість місць'
            },
            editor: {
                create: 'Створення тарифу для клієнтів',
                edit: 'Редагування тарифу для клієнтів',
                removeQuestion: 'Бажаєте видалити даний тариф?',
                removeDescription: 'Даний тариф буде повністю видалено.',
            }
        },
        OptionClasses: {
            list: {
                towing: 'Буксування',
                apart_delivery: 'Доставка в квартиру',
                'apart-delivery': 'Доставка в квартиру',
                pump: 'Підкачати',
                smoke: 'Підкурити',
                drive: 'Драйв',
                'for-testing': 'Тестовий (QA)',
                corporate: 'Корпорація (безгот.)',
                'child-escort': 'Супровід дітей',
                'child-car-seat': 'Автокрісло',
                animals: 'Перевезення тварин',
                delivery: 'Доставка',
                cashless: 'Безготівковий розрахунок',
                technical: 'ТД',
                promo: 'Супер-Економ',
                test: ' Test',
                economy: 'Економ',
                cargo: 'Вантажне таксі',
                forced: 'Forced',
                'pre-order': 'Попереднє замовлення',
                wagon: 'Універсал',
                van: 'Мінівен',
                comfort: 'Комфорт',
                standart: 'Стандарт',
                premium: 'Преміум',
                bonuses: 'Бонуси',
                'food-delivery': 'Доставка їжі',
            },
            table: {
                id: 'Номер',
                className: 'Назва',
                actions: 'Дії'
            },
            create: 'Новий клас опцій',
            edit: 'Редагування класу опцій',
            remove: 'Видалення класу опцій',
            removeQuestion: 'Ви дійсно хочете видалити цей клас опцій ?'
        },
        PaymentTypes: {
            filters: {
                query: 'Запит'
            },
            table: {
                name: 'Назва',
                description: 'Опис',
                orderRequired: 'Замовлення',
                hidden: 'Прихований',
                createdAt: 'Створено',
                actions: 'Дії'
            },
            create: 'Новий тип платежу',
            edit: 'Редагування типу платежу',
            remove: 'Видалення типу платежу',
            removeQuestion: 'Ви дійсно хочете видалити цей тип платежу ?'
        },
        Commissions: {
            title: 'Комісія',
            status: 'Статус',
            brand: 'Бренд',
            statusesList: {
                active: 'Активні',
                inactive: 'Неактивні',
                removed: 'Видалені'
            },
            table: {
                title: 'Назва',
                countOfDrivers: 'Кількість водіїв',
                fixedPerOrder: 'Плата за замовлення(грн.)',
                fixedPerDay: 'Плата за день роботи(грн.)',
                perDayType: 'Тип плати за день',
                fixedPerWeek: 'Плата за тиждень роботи(грн.)',
                fixedPerMonth: 'Плата за місяць роботи(грн.)',
                fixedPerDeliveryOrder: 'Плата за замовлення доставки(грн.)',
                percentagePerDeliveryOrder: 'Процент від замовлення доставки(%)',
                deliveryDelay: 'Затримка(сек.)',
                isDefault: 'Основна',
                brandId: 'Бренд',
                hasPrecedenceForForced: 'Пріоритет в автозахваті',
                actions: 'Дії'
            },
            perDayTypeOptions: {
                'has-orders': 'За дні з замовленнями',
                'has-orders-count-per-five': 'За дні з замовленнями (5 платних днів у тиждень)',
                'since-first-login': 'За вхід у систему'
            },
            editor: {
                create: 'Створення комісії для водіїв',
                edit: 'Редагування комісії для водіїв',
                removeQuestion: 'Бажаєте видалити дану комісію?',
                removeDescription: 'Дана комісія буде повністю видалено.',
            },
            borders: {
                title: 'Цінові пороги',
                actions: 'Дії',
                create: 'Додавання порогу комісії',
                edit: 'Редагування порогу комісії',
                cancel: 'Скасувати редагування',
                notCommissionBorders: 'Для даної комісії ще не створено жодного порогу',
                leftBorder: 'Ліва межа',
                rightBorder: 'Права межа',
                staticValue: 'Статична комісія',
                percentValue: 'Відсоткова комісія'
            },
            transfer: {
                title: 'Переведення водіїв з поточної комісії на обрану',
                commission: 'Комісія',
                driversCount: 'Кількість водіїв: {0}',
                question: 'Ви впевнені ?',
                description: 'Усі водії, які використовують поточну комісію, будуть переведені на обрану'
            }
        },
        PhotoReport: {
            edit: 'Редагувати',
            reasonRequestCreate: {
                createReason: 'Створення причини',
                photoType: 'Тип фото',
                createPhotoType: 'Створити тип фото',
                reasonName: 'Назва причини'
            },
            reasonRequestsList: {
                reasonName: 'Назва причини',
                removeTitle: 'Ви дійсно хочете видалити причину?',
                removeDescription: 'Дана причину буде повністю видалена',
                table: {
                    '#': '#',
                    name: 'Причина',
                    photo: 'Тип фото',
                    actions: 'Дії',
                    createdAt: 'Створено'
                }
            },
            photoReportsList: {
                completeTitle: 'Ви дійсно хочете завершити фотозвіт?',
                completeDescription: 'Описание',
                removeTitle: 'Ви дійсно хочете видалити фотозвіт?',
                removeDescription: 'Даний фотозвіт буде повністю видалений',
                editTitle: 'Редагувати фотозвіт',
                activity: 'Активність',
                activeRequest: 'Активні запити',
                finishedRequest: 'Завершені запити',
                filters: {
                    name: 'Назва',
                    reason: 'Причина',
                    brand: 'Бренд',
                    callSign: 'Позивний'
                },
                table: {
                    '#': '#',
                    requestName: 'Назва',
                    active: 'Активність',
                    reasonName: 'Причина',
                    allDrivers: 'Кількість водіїв',
                    acceptedDrivers: 'Прийнято',
                    rejectedDrivers: 'Відхилено',
                    newDrivers: 'Новий',
                    actions: 'Дії',
                    createdAt: 'Створено',
                }
            },
            requestCreate: {
                filters: {
                    brand: 'Бренд',
                    callSign: 'Позивний',
                    checkCallSign: 'Перевірити позивний',
                    callSigns: 'Позивні'
                },
                validation: 'Валідація',
                createRequest: 'Cтворення запиту',
                reason: 'Причина',
                name: 'Назва фотозвіту',
                optionClass: 'Клас опції',
                commission: 'Комісія',
                modal: {
                    warning: 'Увага !',
                    info: 'Якщо один з обраних позивних вже був доданий в існуючий фото-звіт з аналогічною причиною, - для цього він буде проігнорований.'
                }
            },
            review: {
                title: 'Фотозвіт: "{0}"',
                editComment: 'Натисніть Enter щоб зберегти',
                showPhotoType: 'Показати тип фото',
                hidePhotoType: 'Сховати тип фото',
                filters: {
                    request: 'Запит',
                    brand: 'Бренд',
                    status: 'Статус',
                    comment: 'Коментарій'
                },
                table: {
                    '#': '#',
                    callSign: 'Позивний',
                    brand: 'Бренд',
                    name: 'ПІБ',
                    auto: 'Авто',
                    phoneNumber: 'Телефон',
                    driverCreatedAt: 'Дат. прийняття',
                    commission: 'Комісія',
                    images: 'Фото',
                    status: 'Статус',
                    comment: 'Коментарій'
                }
            },
            statuses: {
                new: 'Новий',
                empty: 'Пустий',
                remake: 'Перезнімається',
                accepted: 'Прийнято',
                rejected: 'Відхилено'
            },
            validation: {
                success: 'Успішно',
                notFound: 'Не знайдено',
                duplicate: 'Дубльовано',
                validationError: 'Помилка валідації',
                inOpenRequest: 'У відкритому фотозвіті'
            }
        },
        CommissionSystems: {
            table: {
                id: 'Номер системи',
                name: 'Назва',
                brandId: 'Бренд',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                drivers: 'Кількість водіїв',
                actions: 'Дії',
                period: 'Період',
                startCalcDate: 'Дата початку відліку',
                onlyForcedOrder: 'Тільки автозахвати'
            },
            editor: {
                create: 'Створення системи комісій для водіїв',
                edit: 'Редагування системи комісій для водіїв',
                removeQuestion: 'Бажаєте видалити дану систему комісій?',
                removeDescription: 'Дана система комісій буде повністю видалено.',
            },
            errors: {
                alreadyExistSystem: 'Система з цією назвою вже існує',
                systemHasDrivers: 'Система вже використовується водіями'
            },
            steps: 'Кроки системи комісій',
            stepsData: {
                count: 'Кількість замовлень',
                commissionId: 'Комісія',
                actions: 'Дії'
            },
            transfer: {
                title: 'Переведення водіїв на поточну систему комісій',
                commission: 'Система комісій',
                driversCount: 'Кількість водіїв: {0}',
                question: 'Ви впевнені ?',
                description: 'Усі водії, які використовують поточну систему комісій, будуть переведені на обрану'
            }
        },
        Penalties: {
            title: 'Штраф',
            brand: 'Бренд',
            table: {
                title: 'Назва',
                fixedPenalty: 'Сума штрафу',
                brandId: 'Бренд',
                actions: 'Дії'
            },
            editor: {
                create: 'Створення штрафу',
                edit: 'Редагування штрафу',
                removeQuestion: 'Бажаєте видалити даний штраф?',
                removeDescription: 'Даний штраф буде повністю видалено.',
            }
        },
        Logging: {
            models: {
                Client: 'Клієнт',
                Driver: 'Водій',
                Operator: 'Оператор',
                ClientBonus: 'Клієнтський бонус',
                Tariff: 'Тариф',
                Resale: 'Перепродажа',
                Penalty: 'Штраф',
                Commission: 'Комісія',
                DriverBonus: 'Водійський бонус',
                CommissionBorder: 'Межа комісії',
                Settings: 'Налаштування',
                Report: 'Звіт'
            },
            actionType: 'Тип дії',
            user: 'Користувач',
            table: {
                userId: 'Користувач',
                actionTypeId: 'Тип дії',
                createdAt: 'Створено',
                action: 'Дія'
            },
            messages: {
                'change-action-type-status': 'Логування дії "{0}" було {1}',
                'setting-edit': 'Налаштування {0} були змінені з {1} на {2}.',
                'withBrand': 'З брендом {0}',
                'setting-change': 'Встановлені користувацькі [{0}] налаштування для бренду {1}',
                'setting-set-default': 'Встановлені стандартні [{0}] налаштування для бренду {1}',
                'report-change-access': 'Доступ звітів змінений для користувача {0} {1}.',
                'addAccess': 'Доданий доступ: {0}.',
                'removeAccess': 'Видалений доступ: {0}.',
                'categoryReport': 'Категорія звіту: ',
                'nameReport': 'Назва звіту: ',
                'report-view': 'Звіт переглянутий [Категорія: {0}, Ім\'я: {1}]',
                'change': '{0} з {1} на {2}',
                'add': 'Додано {0}: {1}',
                'user-login': 'Вхід користувача {0} {1}',
                'delete': '{0} {1} - видалено',
                'operator-delete': 'Користувача {0} (логін: {1}) з роллю "{2}" було видалено',
                'edit': '{0} {1} - змінено: {2}',
                'create': '{0} - створено з параметрами: {1}',
                'deleteField': 'Видалив {0} {1}',
                'resale-create': 'Перепродаж з {0} на {1} (опція: {2}) було створено з параметрами: {3}',
                'resale-edit': 'Поля перепродажу {0} на {1} (опція: {2}) було змінено: {3}',
                'resale-delete': 'Перепродаж з {0} на {1} (опція: {2}) було видалено',
                'change-driver-status': 'Водія {0} було {1}',
                'driverStatus': {
                    'active': 'повернуто до ефіру',
                    'disabled': 'знято з ефіру'
                },
                'enabled': 'увімкнено',
                'disabled': 'вимкнено',
                'send-driver-password': 'Водію {0} відправлено пароль',
                'passwordChanged': 'Пароль користувача',
                'operator-back-to-work': 'Оператора {0} повернено до роботи',
                'financeRemove': '{0} {1} для бренду {2} - видалено',
                'add-driver-payment': 'Створено платіж водію: {0} \nз причиною: {1}\nсумою: {2}\nкоментарем: {3}',
                'reset-imei': 'Скинуто IMEI у {0} водія',
                'sqlQuery': 'Sql запит',
                'meta': 'Meta запит',
                'karma-change': 'Карму водія "{0}" було змінено з {1} на {2}',
                'option-level-edit': 'Рівень опцій було змінено з {0} на {1}'
            }
        },
        LoggingEditor: {
            table: {
                action: 'Дія',
                enabled: 'Включено'
            }
        },
        TechnicalSupport: {
            clientAppeals: {
                title: 'Звернення клієнтів',
                table: {
                    id: '№',
                    type: 'Тип дзвінка',
                    phoneNumber: 'Номер телефону',
                    orderId: 'Номер замовлення',
                    status: 'Статус',
                    reason: 'Причина',
                    comment: 'Коментар',
                    dispatcher: 'Диспетчер',
                    actions: 'Дії'
                },
            },
            callTypes: {
                driver: 'Водій',
                client: 'Клієнт'
            },
            statuses: {
                resolved: 'Вирішено',
                unresolved: 'Не вирішено',
                review: 'Розглядається',
                transferred: 'Передано адміністратору',
                rejected: 'Відхилено'
            },
            CardEditor: {
                title: 'Картка-звернення',
                form: {
                    type: 'Хто телефонував ?',
                    phoneNumber: 'Номер телефону',
                    orderId: 'Номер замовлення',
                    reason: 'Причина',
                    status: 'Статус',
                    comment: 'Коментар',
                    customReason: 'Введіть причину'
                }
            },
            additionalInfo: {
                title: 'Додаткова інформація',
                'client-details': 'По номеру телефону',
                'order-details': 'По номеру замовлення',
                orderData: 'Дані по замовленню',
                payments: 'Платежі в системі',
                paymentsFromFp: 'Платежі в системі FP',
                fpPaymentsTable: {
                    clientId: 'ID клієнта',
                    phoneNumber: 'Номер телефону клієнта',
                    orderId: 'Номер транзакції',
                    amount: 'Сума',
                    status: 'Статус',
                    type: 'Тип',
                    createdAt: 'Створено',
                    new: 'Новий',
                    success: 'Успішно',
                    error: 'Помилка',
                    sandbox: 'Sandbox'
                },
                fpBalanceHistoryTable: {
                    id: 'ID',
                    taxiOrderId: 'Номер замовлення таксі',
                    paymentId: 'Номер платежу',
                    change: 'Зміни',
                    balance: 'Баланс',
                    paymentType: 'Тип платежа',
                    createdAt: 'Створено',
                    system: 'Система',
                    cashback: 'Кешбек',
                    refill: 'Поповнення',
                    trip: 'Поїздка'
                },
                orderHistory: 'Останні замовлення',
                balanceHistory: 'Останні зміни балансу',
                fpData: 'Дані в системі FP',
                bonuses: 'Приймає участь в бонусній системі "{0}" ({1})',
                corporation: 'Відноситься до корпорації "{0}"',
                group: 'Група клієнтів: "{0}"',
                cashback: 'Бере участь у системі кешбеку: "{0}"'
            },
        },
        Establishments: {
            table: {
                name: 'Назва',
                'name:uk': 'Назва (UK)',
                'name:ru': 'Назва (RU)',
                'name:en': 'Назва (EN)',
                description: 'Опис',
                'description:uk': 'Опис (UK)',
                'description:ru': 'Опис (RU)',
                'description:en': 'Опис (EN)',
                status: 'Статус',
                cookTime: 'Час приготування',
                minimalPrice: 'Мін. сума замовлення',
                place: 'Адреса',
                type: 'Тип',
                category: 'Категорія',
                margin: 'Націнка',
                brand: 'Бренд',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                order: 'Сортування',
                position: 'Позиція',
                openTime: 'Час відкриття',
                closeTime: 'Час закриття',
                closedOnAlarm: 'Під час тривоги',
                commission: 'Комісія'
            },
            remove: {
                title: 'Видалення закладу',
                question: 'Ви дійсно хочете видалити заклад ?'
            },
            settings: {
                title: 'Налаштування',
                minutesPerKilometer: 'Тривалість проїзду 1км шляху'
            },
            active: 'Активно',
            inactive: 'Не активно',
            opened: 'Відкрито',
            closed: 'Закрито',
            closedOnAlarm: 'Закрито під час тривоги',
            openOnAlarm: 'Відкрито під час тривоги'
        },
        EstablishmentEditor: {
            name: 'Назва',
            description: 'Опис',
            status: 'Статус',
            cookTime: 'Час приготування (хв)',
            minimalPrice: 'Мін. сумма доставки',
            place: 'Адреси',
            type: 'Тип',
            category: 'Категорія',
            brand: 'Бренд',
            managerPhoneNumber: 'Номер телефону менеджера',
            create: 'Створення нового закладу',
            edit: 'Редагування закладу',
            openTime: 'Час відкриття',
            closeTime: 'Час закриття',
            commission: 'Комісія'
        },
        DriverNewsEditor: {
            articleData: 'Дані новини'
        },
        AddDriverArticle: {
            sendTo: {
                all: 'Всі',
                selected: 'Обрані позивні'
            }
        },
        DriverNews: {
            table: {
                id: 'Номер новини',
                createdAt: 'Створена',
                sendTo: 'Кому відправлена',
                status: 'Статус',
                header: 'Назва',
                text: 'Текст новини',
                actions: 'Дії'
            },
            status: {
                shown: 'Опублікована',
                hide: 'Прихована'
            },
            sendTo: {
                all: 'Всім',
                selected: 'Обраним позивним'
            },
            delete: 'Видалити',
            cancel: 'Скасувати',
            deleteTitle: 'Видалити новину?',
            cannotBeUndone: 'Ця дія незворотна'
        },
        News: {
            selects: {
                all: 'Всім',
                leader: 'Лідерам',
                business: 'Бізнесам'
            },
            count: 'Кількість новин',
            header: 'Інформація для партнерів',
            showTo: 'Показати',
            showText: 'Публікація',
            latePublication: 'Відкладена публікація',
            publicationDate: 'Дата публікації',
            publicationTime: 'Час публікації',
            text: 'Текст публікації',
            image: 'Оберіть зображення',
            share: 'Оберіть реферальний код, щоб поділитись',
            noCode: 'У вас немає жодного реферального коду. Створіть його перед тим як поділитись',
            edit: 'Редагування публікації',
            create: 'Нова публікація',
            shareImageBlock: {
                code: {
                    size: 'Розмір коду(px)',
                    position: 'Позиція',
                    positions: {
                        'top-left': 'Зверху зліва',
                        'top-right': 'Зверху справа',
                        'bottom-left': 'Знизу зліва',
                        'bottom-right': 'Знизу справа'
                    }
                },
                addQRCode: 'Додати QR код'
            }
        },
        Notification: {
            count: 'Кількість повідомлень',
            drivers: 'Готові до відправлення',
            filters: {
                selectAll: 'Обрати всіх клієнтів',
                phones: 'Позивні',
                success: 'Успішно',
                duplicate: 'Дублікати',
                notFound: 'Не знайдено',
                withoutToken: 'Без токена',
                validationError: 'Помилка валідації'
            },
            message: {
                title: 'Заголовок *',
                body: 'Текст',
                image: 'Посилання на зображення'
            },
            result: {
                title: 'Результат',
                androidSuccess: 'Android успішно',
                androidFailure: 'Android не успішно',
                iosSuccess: 'iOS успішно',
                iosFailure: 'iOS не успішно'
            },
            error: {
                invalidToken: 'Не вірний токен пристрою',
                emptyToken: 'Токен пристрою не надіслано',
                requiredData: 'Поле з тілом запиту не надіслано',
                couldNotParsed: 'Неможливо прочитати тіло запиту',
                InvalidRegistration: 'Недійсна реєстрація',
                NotRegistered: 'Не зареєстровано',
                InvalidPackageName: 'Недійсна назва пакета',
                MismatchSenderId: 'Невідповідність ідентифікатора відправника',
                InvalidParameters: 'Недійсні параметри',
                MessageTooBig: 'Повідомлення занадто велике',
                InvalidDataKey: 'Недійсний ключ даних',
                Unavailable: 'Недоступно',
                InternalServerError: 'Внутрішня помилка сервера',
                DeviceMessageRateExceeded: 'Перевищена швидкість повідомлення на пристрої',
                BadCollapseId: 'Неправильний ідентифікатор',
                BadDeviceToken: 'Неправильний маркер пристрою',
                BadExpirationDate: 'Неправильний термін придатності',
                BadMessageId: 'Неправильний ідентифікатор повідомлення',
                BadPriority: 'Неправильний пріоритет',
                BadTopic: 'Неправильна тема',
                DeviceTokenNotForTopic: 'Токен пристрою не належить даній темі',
                DuplicateHeaders: 'Дублікати заголовків',
                IdleTimeout: 'Час очікування не працює',
                MissingDeviceToken: 'Відсутній маркер пристрою',
                MissingTopic: 'Відсутня тема',
                PayloadEmpty: 'Корисне навантаження порожнє',
                TopicDisallowed: 'Тема заборонена',
                BadCertificate: 'Неправильний сертифікат',
                BadCertificateEnvironment: 'Неправильне середовище сертифікатів',
                ExpiredProviderToken: 'Термін дії провайдера минув',
                Forbidden: 'Заборонено',
                InvalidProviderToken: 'Недійсний маркер постачальника',
                MissingProviderToken: 'Відсутній маркер постачальника',
                BadPath: 'Поганий шлях',
                MethodNotAllowed: 'Метод заборонений',
                Unregistered: 'Незареєстрований',
                PayloadTooLarge: 'Корисне навантаження занадто велике',
                TooManyProviderTokenUpdates: 'Занадто багато оновлень маркера постачальника',
                TooManyRequests: 'Занадто багато запитів',
                ServiceUnavailable: 'Послуга недоступна',
                Shutdown: 'Закрито'
            }
        },
        EstablishmentsCategories: {
            table: {
                name: 'Назва',
                'name:uk': 'Назва (UK)',
                'name:ru': 'Назва (RU)',
                'name:en': 'Назва (EN)',
                enabled: 'Статус',
                image: 'Зображення',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                create: 'Новая категорія',
                edit: 'Редагування категорії',
                order: 'Сортування',
                position: 'Позиція'
            }
        },
        EstablishmentsTypes: {
            table: {
                name: 'Назва',
                'name:uk': 'Назва (UK)',
                'name:ru': 'Назва (RU)',
                'name:en': 'Назва (EN)',
                description: 'Опис',
                'description:uk': 'Опис (UK)',
                'description:ru': 'Опис (RU)',
                'description:en': 'Опис (EN)',
                status: 'Статус',
                statuses: {
                    draft: 'Чорновик',
                    publish: 'Опубліковано'
                },
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                create: 'Новий тип',
                edit: 'Редагування типу'
            },
            deletingType: 'Видалення типу закладу',
            areYouSureToDelete: 'Ви дійсно бажаєте видалити тип закладу?'
        },
        Sections: {
            table: {
                name: 'Назва',
                'name:uk': 'Назва (UK)',
                'name:ru': 'Назва (RU)',
                'name:en': 'Назва (EN)',
                description: 'Опис',
                establishmentAddress: 'Адреса закладу',
                'description:uk': 'Опис (UK)',
                'description:ru': 'Опис (RU)',
                'description:en': 'Опис (EN)',
                status: 'Статус',
                statuses: {
                    draft: 'Чорновик',
                    publish: 'Опубліковано'
                },
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                create: 'Новий розділ',
                margin: 'Націнка',
                edit: 'Редагування розділу',
                establishment: 'Заклад',
                order: 'Сортування',
                position: 'Позиція'
            },
            deleting: 'Видалення розділу',
            areYouSureToDelete: 'Ви точно бажаєте видалити цей розділ?'
        },
        Products: {
            table: {
                name: 'Назва',
                'name:uk': 'Назва (UK)',
                'name:ru': 'Назва (RU)',
                'name:en': 'Назва (EN)',
                weight: 'Кількість',
                establishmentAddress: 'Адреса закладу',
                price: 'Ціна',
                isByWeight: 'Ваговий',
                shortDescription: 'Короткий опис',
                'shortDescription:uk': 'Короткий опис (UK)',
                'shortDescription:ru': 'Короткий опис (RU)',
                'shortDescription:en': 'Короткий опис (EN)',
                detailedDescription: 'Детальний опис',
                'detailedDescription:uk': 'Детальний опис (UK)',
                'detailedDescription:ru': 'Детальний опис (RU)',
                'detailedDescription:en': 'Детальний опис (EN)',
                status: 'Статус',
                establishmentPrice: 'Ціна (заклад)',
                clientPrice: 'Ціна (клієнт)',
                brand: 'Бренд',
                section: 'Розділ',
                image: 'Зображення',
                createdAt: 'Створено',
                published: 'Наявність',
                updatedAt: 'Оновлено',
                actions: 'Дії',
                establishment: 'Заклад'
            },
            quantityTypes: {
                pc: 'шт',
                g: 'г',
                kg: 'кг',
                ml: 'мл'
            },
            create: 'Новий товар',
            dblClickToEdit: 'Натисніть на ціну двічі для редагування',
            edit: 'Редагування товару',
            remove: {
                title: 'Видалення товару',
                question: 'Ви дійсно хочете видалити цей товар?'
            },
            statuses: {
                review: 'На розгляді',
                draft: 'Чорновик',
                'not-available': 'Немає в наявності',
                publish: 'Опубліковано'
            }
        },
        404: {
            title: 'Упс!',
            text: 'Схоже, ви перебуваєте на незвіданій території. Ми ще не знаємо про цю сторінку. На щастя, ми знаємо зворотній шлях.',
            return: 'Назад'
        }
    },
    buttons: {
        submit: 'Увійти',
        cancel: 'Відмінити',
        save: 'Зберегти',
        change: 'Змінити',
        remove: 'Видалити',
        excel: 'Завантажити таблицю',
        upload: 'Завантажити',
        selectAll: 'Обрати всі',
        edit: 'Редагувати',
        returnToSearch: 'Повернути в пошук',
        reset: 'Скинути',
        apply: 'Застосувати',
        ok: 'OK',
        find: 'Знайти',
        clear: 'Очистити',
        create: 'Створити',
        check: 'Перевірити',
        validate: 'Валідувати',
        generate: 'Сформувати',
        generateInExcel: 'Сформувати в Excel',
        backToWork: 'Повернути на роботу',
        hide: 'Приховати',
        send: 'Відправити',
        complete: 'Завершити',
        blocked: 'Заблокувати',
        add: 'Додати',
        recalculate: 'Перерахувати',
        restore: 'Відновити',
        transfer: 'Перевести',
        duplicate: 'Дублювати',
        browse: 'Обрати',
        checkPhones: 'Перевірити номери',
        search: 'Пошук',
    },
    roles: {
        all: 'Всі',
        intern: 'Стажист',
        operator: 'Оператор',
        accountant: 'Бухгалтер',
        manager: 'Менеджер',
        'corporate-admin': 'Корпоративний адміністратор',
        'corporate-user': 'Корпоративний користувач',
        boss: 'Директор',
        client: 'Клієнт',
        admin: 'Адміністратор',
        'sales-manager': 'Менеджер з продажу',
        driver: 'Водій',
        leader: 'Лідер',
        'admin-delivery': 'Адміністратор доставки',
        'admin-establishment': 'Адміністратор ресторану',
        'manager-establishment': 'Менеджер ресторану',
        'manager-establishment-ext': 'Менеджер ресторану (розширений)'
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    messages: {
        error: {
            badRequest: 'Заповніть усі поля',
            missedImportCsv: 'У архіві відсутній файл import.csv (.xml)',
            uploadFileError: 'Помилка у файлі import.csv (.xml)',
            orderNotFound: 'Замовлення не знайдено',
            borderIsAlreadyExist: 'Межі даного порогу перетинаються з межами іншого порогу',
            existPaymentByPenalty: 'В системі вже є платежі з даним штрафом.',
            duplicateCallSign: 'Користувач з таким позивним вже існує. Оберіть інший позивний.',
            cantDeleteCorpAdmin: "Неможливо видалити адміністратора корпорації за наявності користувачів",
            duplicateLoginName: 'Користувач з таким логіном вже існує. Оберіть інший логін.',
            duplicatePhoneNumber: 'Користувач з обраним номером телефону вже існує.',
            invalidPhone: 'Некоректний номер телефону',
            autologout: 'Сесія була закрита через відсутність активності',
            invalidLogin: 'Логін не коректний',
            invalidPassword: 'Пароль не коректний',
            requiredPhoneNumber: 'Введіть SIP',
            invalidOperator: 'Оператора не знайдено',
            accountRemoved: 'Акаунт було видалено',
            invalidFormat: 'Некоректний формат даних',
            invalidInteger: 'Потрібно записати цілочисельне значення. Наприклад: 100',
            invalidDecimal: 'Потрібно записати дробове або цілочисельне значення. Наприклад: 20 або 20.5',
            invalidBoolean: 'Можливі тільки значення "true" або "false"',
            withoutType: 'Невірно вказаний тип значення або тип значення відсутній',
            driversNotFound: 'Водіїв не знайдено',
            findRequestWithThisReason: 'Неможливо видалити причину, при наявності активного фотозвіту з цією причиною',
            cannotChangeReason: 'Неможливо змінити причину, при наявності активного фотозвіту з цією причиною',
            requestAlreadyCompleted: 'Фотозвіт уже завершений',
            notFoundCallSign: 'Позивні не знайдені',
            imageIsTooLarge: 'Завантажте фото розміру <5мб',
            unknown: 'Невідома помилка',
            notifications: {
                InvalidRegistration: 'Недійсна реєстрація',
                NotRegistered: 'Не зареєстровано',
                InvalidPackageName: 'Недійсна назва пакета',
                MismatchSenderId: 'Невідповідність ідентифікатора відправника',
                InvalidParameters: 'Недійсні параметри',
                MessageTooBig: 'Повідомлення занадто велике',
                InvalidDataKey: 'Недійсний ключ даних',
                Unavailable: 'Недоступно',
                InternalServerError: 'Внутрішня помилка сервера',
                DeviceMessageRateExceeded: 'Перевищена швидкість повідомлення на пристрої',
                invalidToken: 'Не вірний токен пристрою',
                emptyToken: 'Токен пристрою не надіслано',
                requiredData: 'Поле з тілом запиту не надіслано',
                couldNotParsed: 'Неможливо прочитати тіло запиту',
                noRecords: 'Не знайдено жодного запису',
                unknown: 'Невідома помилка'
            },
            brand: {
                alreadyExists: 'Бренд з таким телефоном чи кодом уже існує',
                brandNotFound: 'Бренд не знайдено'
            },
            payments: {
                emptyPayment: "Неможливо провести порожній платіж.",
                zeroPayment: "Неможливо провести нульовий платіж.",
                emptyPenalty: "Сума має бути більше 0 грн.",
                isNotNumericPaymentSum: "Сума має бути в числовому форматі.",
                moreThenMaxBalance: "Неможливо провести операцію на суму більше 1 000 000 грн.",
                lessThenMinBalance: "Неможливо провести операцію на суму менше 1 000 000 грн.",
                emptyPaymentTypeId: "Тип платежу не вказано",
                invalidPaymentTypeId: "Тип платежу не знайдено",
                emptyOrderId: "Номер замовлення не вказано",
                findMoreThanOnePayment: "Платіж уже існує!",
                orderNotFound: "Замовлення відсутнє або належить іншому водієві"
            },
            support: {
                paymentsNotFound: 'Платежі не знайдено',
                orderNotFound: 'Замовлення не знайдено',
                incorrectPhoneNumber: 'Некоректний номер телефону',
                clientNotFound: 'Клієнта не знайдено'
            },
            addresses: {
                alreadyExist: 'Адреса з вказаними параметрами вже існує!'
            },
            forms: {
                alreadyHasAnswers: 'Це питання має відповіді'
            },
            optionClasses: {
                notFound: 'Клас опцій не знайдено',
                foundOptions: 'Знайдено опції цього класу'
            },
            paymentTypes: {
                notFound: 'Тип платежу не знайдено',
                foundPayments: 'Знайдені платежі цього типу'
            },
            cantReturnRemovedDriver: 'Ви не можете повернути звільненого водія в ефір',
            optionClassExist: 'Ця опція уже обрана для іншого бренду',
            cantCancelActiveOrder: 'Ви не можете відмінити дане замовлення, поки воно відкрите',
            wrongToken: 'Не вірний токен авторизації',
            requiredAuthorizationToken: 'Потрібен токен авторизації',
            driverInActivePhotoReport: 'Цей водій в активному фотозвіті',
            lessThanMin: 'Менше мінімального значення',
            moreThanMax: 'Більше максимального значення',
            driverRestricted: 'Цей водій не належить Вашому бренду',
            tooManyChars: 'Занадто багато символів',
            fileSizeExceeded: 'Максимальний розмір файлу: {0} мб'
        },
        success: {
            deletedArticle: 'Новина була видалена',
            savedArticle: 'Новина збережена',
            createdArticle: 'Новина створена',
            foundCallSign: 'Позивний знайдений',
            createdPhotoRequest: 'Фотозвіт створений для {0} водіїв',
            closedPhotoRequest: 'Фотозвіт успішно завершено',
            success: 'Операція успішно виконана',
            duplicate: 'Замовлення успішно продубльовано',
            copy: 'Cкопійовано в буфер обміну'
        }
    },
    browserNotify: {
        message: 'Повідомлення',
        applyNotifications: 'Ви дозволили показувати спливаючi повiдомлення',
        new: 'Нове замовлення',
        cancel: 'Замовлення вiдмiнено',
        sos: 'SOS виклик',
        late: 'Запiзнення на виклик',
        client: 'Клієнт: ',
        address: 'Адреса: ',
        availability: 'Немає машин',
        'client-refused': 'Скасовано клієнтом',
        driver: 'Скасував водiй',
        operator: 'Скасував оператор'
    },
    statuses: {
        all: 'Всі',
        new: 'Нове',
        waiting: 'В очікуванні',
        searching: 'Пошук водія',
        arrived: 'Прибув',
        accepted: 'Призначено',
        landed: 'З пасажиром',
        completed: 'Завершено',
        cancelled: 'Скасовано',
        pause: 'Замовлення призупинено',
        delivery: {
            all: 'Всі',
            new: 'Нове',
            accepted: 'Прийнято',
            canceledKitchen: "Кухня скасувала",
            notAccepted: "Не прийнято",
            paid: "Сплачено",
            paymentWait: "Очікується оплата",
            cooking: "Готується",
            canceledClient: "Клієнт скасував",
            canceledClientPayment: "Скасовано (після оплати)",
            readyForDelivery: "Готово до відправки",
            handedToCourier: "Передано кур'єру",
            delivered: "Доставлено",
            noInfo: 'Н/І',
            undefined: 'Н/І'
        }
    },
    scopes: {
        taxi: 'Таксі',
        delivery: 'Доставка',
        all: 'Всі'
    },
    actionTypes: {
        'setting-edit': 'Редагування налаштувань',
        'setting-change': 'Зміна налаштувань',
        'setting-set-default': 'Встановлення налаштувань за замовчуванням',
        'report-change-access': 'Зміна доступу звіту',
        'report-view': 'Перегляд звіту',
        'client-create': 'Створення клієнта',
        'client-edit': 'Редагування клієнта',
        'driver-create': 'Створення водія',
        'driver-edit': 'Редагування водія',
        'driver-delete': 'Видалення водія',
        'operator-create': 'Створення оператора',
        'operator-edit': 'Редагування оператора',
        'operator-delete': 'Видалення оператора',
        'user-login': 'Вхід користувача',
        'client-bonus-create': 'Створення клієнтського бонусу',
        'client-bonus-edit': 'Редагування клієнтського бонусу',
        'tariff-create': 'Створення тарифу',
        'tariff-edit': 'Редагування тарифу',
        'tariff-delete': 'Видалення тарифу',
        'resale-create': 'Створення перепродажу',
        'resale-edit': 'Редагування перепродажу',
        'resale-delete': 'Видалення перепродажу',
        'commission-create': 'Створення комісії',
        'commission-edit': 'Редагування комісії',
        'commission-delete': 'Видалення комісії',
        'commission-border-create': 'Створення кордону комісії',
        'commission-border-edit': 'Редагування кордону комісії',
        'commission-border-delete': 'Видалення кордону комісії',
        'penalty-create': 'Створення штрафу',
        'penalty-edit': 'Редагування штрафу',
        'penalty-delete': 'Видалення штрафу',
        'driver-bonus-create': 'Створення водійського бонусу',
        'driver-bonus-edit': 'Редагування водійського бонусу',
        'change-driver-status': 'Зміна статусу водія',
        'change-action-type-status': 'Зміни в налаштуваннях активності',
        'client-bonus-delete': 'Видалення клієнтського бонусу',
        'driver-bonus-delete': 'Видалення водійського бонусу',
        'send-driver-password': 'Відправка пароля водію',
        'operator-back-to-work': 'Повернення до роботи',
        'report-edit': 'Редагування звіту',
        'report-create': 'Створення звіту',
        'add-driver-payment': 'Створення платежа водію',
        'reset-imei': 'Скинуто IMEI',
        'karma-change': 'Зміна карми',
        'option-level-edit': 'Зміна рівня опцій'
    },
    reasons: {
        all: 'Всі',
        timeout: 'Великий час подачі',
        'broken-connection': 'Обрив дзвінка',
        'no-more-cars': 'Немає машин',
        'not-order': 'Не замовлення',
        police: 'ДАІ',
        'client-refused': 'Скасовано клієнтом',
        breakdown: 'Зламався',
        other: 'Інше',
        null: 'Не SOS',
        'accidental-accept': 'Прийнято випадково',
        'no-connection-with-driver': 'Немає зв\'язку з водієм',
        answerphone: 'Автовідповідач'
    },
    driverStatuses: {
        all: 'Всі',
        active: 'В ефірі',
        disabled: 'Зняті з ефіру',
        online: 'Онлайн',
        removed: 'Звільнені',
        offline: 'Офлайн'
    },
    bonusSystem: {
        'true': 'Активна',
        'false': 'Неактивна'
    },
    operatorStatuses: {
        all: 'Всі',
        online: 'Онлайн',
        offline: 'Офлайн',
        removed: 'Звільнені'
    },
    timePicker: {
        pm: 'День',
        am: 'Ніч'
    },
    table: {
        load: 'Дані завантажуються',
        noData: 'Дані відсутні'
    },
    noDataText: 'Дані відсутні',
    dataIterator: {
        loadingText: 'Завантаження'
    },
    date: {
        fromDate: 'Початкова дата',
        toDate: 'Кінцева дата',
        date: 'Дата'
    },
    close: 'Закрити',
    others: 'інших',
    applyFilters: 'Застосувати фільтри',
    filters: 'Фільтрування',
    system: 'Система',
    status: 'Статус',
    outOf: 'з',
    currency: ' грн',
    answers: {
        yes: 'Так',
        no: 'Ні'
    },
    title: 'Назва',
    apiVersion: 'Версія API',
    clientVersion: 'Версія клієнта',
    orderId: 'Номер замовлення',
    chooseImage: 'Оберіть зображення',
    pagination: {
        ariaLabel: {
            previous: 'previous',
            page: 'page',
            next: 'next',
            wrapper: 'wrapper',
            currentPage: 'current page'
        }
    }
};
